import PropTypes from 'prop-types';
import React, { useState } from 'react';
import clsx from 'clsx';
import Glyphicon from '../Glyphicon/index.js';

/**
 * Chips are variation of the button family. They allow for a segmented control with a static label and an
 * attached action button populated by a supplied glyph.
 *
 */
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const renderChipWithGlyph = (label, glyph, onClick, uiContext, divProps, chipClassname) => {
  const isInput = uiContext === 'input';
  const customProps = {
    onClick,
    onKeyDown: onClick,
    role: 'button',
    tabIndex: '0'
  };
  return /*#__PURE__*/_jsxs("div", {
    className: chipClassname,
    ...divProps,
    onClick: !isInput ? onClick : undefined,
    onKeyDown: !isInput ? onClick : undefined,
    children: [/*#__PURE__*/_jsx("span", {
      children: label
    }), glyph && /*#__PURE__*/_jsx("span", {
      className: "cursor-pointer margin-left-2",
      ...(isInput && customProps),
      "aria-label": glyph,
      children: /*#__PURE__*/_jsx(Glyphicon, {
        glyph: glyph
      })
    })]
  });
};
function Chip(_ref) {
  var _div;
  let {
    glyph,
    className,
    label,
    uiContext = 'default',
    onClick = () => {},
    ...rest
  } = _ref;
  const [isActive, setIsActive] = useState(false);
  const chipClassname = clsx({
    chip: true,
    btn: true,
    active: isActive,
    'filter-chip': uiContext === 'filter',
    'overlay-chip': uiContext === 'overlay',
    'input-chip display-inline-flex align-items-center': uiContext === 'input',
    'inquiry-chip margin-1': uiContext === 'inquiry',
    'inquiry-chip-inverted margin-1': uiContext === 'inquiryInverted'
  }, className);
  delete rest.filterName;
  const onClickHandler = event => {
    // Check if the event is a click or a keydown event with the Enter key
    if (event.type === 'click' || event.type === 'keydown' && event.key.toLowerCase() === 'enter') {
      if (uiContext !== 'inquiry') {
        setIsActive(true);
      }
      onClick(event);
    }
  };
  const divProps = {
    'data-cmp': 'chip',
    ...rest
  };
  const renderChipContainer = containerClassNames => /*#__PURE__*/_jsx("div", {
    className: containerClassNames,
    ...divProps,
    onClick: onClickHandler,
    onKeyDown: onClickHandler,
    role: "button",
    tabIndex: "0",
    children: _div || (_div = /*#__PURE__*/_jsx("div", {
      className: chipClassname,
      children: /*#__PURE__*/_jsx("span", {
        className: "cursor-pointer",
        children: label
      })
    }))
  });
  let chipComponent;
  switch (uiContext) {
    case 'filter':
      chipComponent = renderChipContainer('padding-horizontal-1 padding-vertical-2');
      break;
    case 'input':
      chipComponent = renderChipWithGlyph(label, glyph, onClickHandler, uiContext, divProps, chipClassname);
      break;
    case 'inquiry':
    case 'inquiryInverted':
      chipComponent = renderChipContainer('display-inline-block');
      break;
    default:
      chipComponent = renderChipWithGlyph(label, glyph, onClickHandler, uiContext, divProps, chipClassname);
      break;
  }
  return chipComponent;
}
export default Chip;